<template>
  <v-dialog persistent v-model="dialog" max-width="700">
    <v-card>
      <v-card-title class="headline">
        Change status for {{ rowsAmount }} row(s) on Ready for import?
      </v-card-title>
      <v-card-text>
        Status will be changed for {{ rowsAmount }} row(s), these rows that have
        "Match score" with Green smiley, last sold for the last 36 month and
        these rows do not have multi-matches.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="error" @click="close">Cancel</v-btn>
        <v-btn
          text
          color="primary"
          :disabled="loading || !rowsAmount"
          @click="handleChange"
        >
          Change
          <v-progress-circular
            indeterminate
            class="ml-2"
            color="primary"
            size="16"
            width="2"
            v-if="loading"
          />
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { processingResultsApiV1 } from '@/api/v1';
import { processingResultsApiV2 } from '@/api/v2';

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      rowsAmount: 0
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.fetchSmartStatusRowsAmount();
    },
    close() {
      this.dialog = false;
    },
    async fetchSmartStatusRowsAmount() {
      const resultId = this.$route.params.result_id;
      this.loading = true;

      this.rowsAmount = await (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      ).fetchSmartStatusRowsAmount(resultId);
      this.loading = false;
    },
    handleChange() {
      this.$emit('onChange', this.status);
      this.close();
    }
  }
};
</script>
